function viewportSize() {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  return { width, height };
}

/**
 * Checks if an element is approximately visible.
 *
 * By approximately, I mean that it is fully within the viewport's bounds.
 * However, if the element is hidden in its parent's overflow (i.e. if the
 * element still needs to be scrolled to) then this may give a false positive.
 *
 * If the elements is guaranteed to be scrolled to, this should always give
 * a correct result.
 *
 * @param {HTMLElement} element
 */
function isApproxVisible(element) {
  const { top, bottom, left, right } = element.getBoundingClientRect();

  return (
    top >= 0 &&
    left >= 0 &&
    bottom <= viewportSize().height &&
    right <= viewportSize().width
  );
}

export function scrollEntireViewportTo(element) {
  if (!isApproxVisible(element)) element.scrollIntoView({ block: 'end' });
}

export function scrollListboxTo(
  { element, listboxNode },
  onLoadMoreItems,
  numberValuesRendered
) {
  if (
    element &&
    listboxNode &&
    listboxNode.scrollHeight > listboxNode.clientHeight
  ) {
    const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
    const elementBottom = element.offsetTop + element.offsetHeight;

    const elementIdx = element.getAttribute('data-index');

    if (
      elementBottom + 23 > scrollBottom &&
      elementIdx > numberValuesRendered - 3 &&
      onLoadMoreItems
    ) {
      onLoadMoreItems();
    }

    if (elementBottom > scrollBottom) {
      listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
    }

    if (element.offsetTop < listboxNode.scrollTop) {
      listboxNode.scrollTop = element.offsetTop;
    }

    scrollEntireViewportTo(listboxNode);
    scrollEntireViewportTo(element);
  }
}
